import { render, staticRenderFns } from "./truck-form.vue?vue&type=template&id=3dbf9647&scoped=true&"
import script from "./truck-form.vue?vue&type=script&lang=js&"
export * from "./truck-form.vue?vue&type=script&lang=js&"
import style0 from "./truck-form.vue?vue&type=style&index=0&id=3dbf9647&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf9647",
  null
  
)

export default component.exports